import React, { useEffect, useState } from 'react'
import { navigate } from 'gatsby'
import Autosuggest from 'react-autosuggest'
import algoliasearch from 'algoliasearch/lite'
import { Configure, InstantSearch, connectAutoComplete } from 'react-instantsearch-dom'

const algoliaClient = algoliasearch(process.env.GATSBY_ALGOLIA_APPLICATION_ID, process.env.GATSBY_ALGOLIA_SEARCH_KEY)

const searchClient = {
  ...algoliaClient,
  search(requests) {
    if (requests.every(({ params }) => !params.query)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0
        }))
      })
    }
    return algoliaClient.search(requests)
  }
}

const Search = () => (
  <InstantSearch searchClient={searchClient} indexName='netlify_59698124-9786-458a-9342-282ba1fc0a04_main_all'>
    <AutoComplete />
    <Configure hitsPerPage={5} />
  </InstantSearch>
)

const renderInputComponent = (inputProps) => (
  <div className='relative -mt-1 overflow-auto p-1 lg:mr-2 lg:p-1 lg:shadow-none'>
    <input
      {...inputProps}
      className='ring-rounded w-full rounded-full border bg-white px-4 py-2 text-black shadow duration-500 ease-in-out focus:outline-none focus:ring focus:ring-orange-500 focus:ring-opacity-50'
    />
    <div className='pointer-events-none absolute inset-y-0 right-0 flex items-center lg:pr-4'>
      <svg xmlns='http://www.w3.org/2000/svg' className='mr-6 h-8 w-8 lg:mr-0 lg:h-6 lg:w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z' />
      </svg>
    </div>
  </div>
)

const Hits = ({ hits, refine }) => {
  const [value, setValue] = useState('')
  const [prevHits, setPrevHits] = useState([])

  useEffect(() => {
    setPrevHits(hits)
  }, [hits])
  return (
    <Autosuggest
      suggestions={prevHits}
      multiSection={false}
      focusInputOnSuggestionClick={false}
      onSuggestionsFetchRequested={({ value }) => refine(value)}
      onSuggestionsClearRequested={() => setPrevHits([])}
      onSuggestionSelected={(evt, { suggestion }) => {
        evt.preventDefault()
        navigate(suggestion.url)
      }}
      getSuggestionValue={(prevHits) => prevHits.title}
      renderSuggestion={(prevHits) => {
        return (
          <div className='flex cursor-pointer flex-row items-start gap-4 whitespace-normal border-b border-gray-200 bg-white p-4 text-left text-black hover:bg-gray-100'>
            <img src={prevHits.image} alt='' className='mt-2 aspect-square w-12 bg-orange-500' />
            <div className='flex flex-col'>
              <span className='text-orange-500'>{prevHits.title}</span>
              <small className='text-sm'>{prevHits.description}</small>
            </div>
          </div>
        )
      }}
      inputProps={{
        placeholder: 'Search',
        'aria-label': 'Search Parking4Less',
        value,
        onChange: (event, { newValue, method }) => {
          setValue(newValue)
        }
      }}
      renderInputComponent={renderInputComponent}
      renderSectionTitle={(section) => section.index}
      getSectionSuggestions={(section) => section.hits}
    />
  )
}

const AutoComplete = connectAutoComplete(Hits)

export default React.memo(Search)
